import { render, staticRenderFns } from "./story-item.vue?vue&type=template&id=478acf3d&scoped=true&"
import script from "./story-item.vue?vue&type=script&lang=js&"
export * from "./story-item.vue?vue&type=script&lang=js&"
import style0 from "./story-item.vue?vue&type=style&index=0&id=478acf3d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478acf3d",
  null
  
)

export default component.exports